<template>
  <div>
    <FaqPage />

  </div>
</template>

<script>
import FaqPage from '@/components/faq/index.vue'


export default {
  name: 'Faq',
  components: {
    FaqPage,

  }
}
</script>
